<div *ngIf="loading | async" class="loader">
    <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<router-outlet></router-outlet>

<!-- end auth-page-wrapper -->
<app-toast aria-live="polite" aria-atomic="true"></app-toast>